class WmdShowcase extends HTMLElement {
  constructor() {
    super();
    this.scrollLeftButton = this.querySelector('.wmd-showcase .scroll-btn.left');
    this.scrollRightButton = document.querySelector('.wmd-showcase .scroll-btn.right');
    this.container = this.querySelector('.wmd-showcase .container');
    this.scrollLeftButton.addEventListener('click', () => this.scrollByVisibleChild('left'));
    this.scrollRightButton.addEventListener('click', () => this.scrollByVisibleChild('right'));
  }

  scrollByVisibleChild(direction) {

    let children = Array.from(this.container.children);
    // Find the leftmost visible child
    let leftmostChild = children.find(child => {
      let rect = child.getBoundingClientRect();
      let containerRect = this.container.getBoundingClientRect();
      return rect.left >= containerRect.left && rect.left < containerRect.right;
    });

    if (leftmostChild) {
      let scrollAmount = leftmostChild.offsetWidth;
      this.container.scrollBy({ left: direction === 'right' ? scrollAmount : -scrollAmount, behavior: 'smooth' });
    }
  }

}

customElements.define('wmd-showcase', WmdShowcase);
